import { ActiveModelSerializer } from 'miragejs';

export default class extends ActiveModelSerializer {
  include = ['periods'];
  embed = true;
  serializeIds = 'never';
}
